export type PaginationErrorCode = "invalid_pagination"

export class PaginationValidationError extends Error {
  readonly code: PaginationErrorCode = "invalid_pagination"
  readonly statusCode = 400

  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = "PaginationValidationError"
  }
}

export const isPaginationValidationError = (error: unknown): error is PaginationValidationError => {
  if (!error || typeof error !== "object") return false
  const anyError = error as Partial<PaginationValidationError>
  return (
    anyError.name === "PaginationValidationError" &&
    anyError.code === "invalid_pagination" &&
    anyError.statusCode === 400
  )
}
